import { ApolloClient, HttpLink, InMemoryCache, makeVar } from '@apollo/client'

import { API_URL } from './constants'

const cache = new InMemoryCache()
const link = new HttpLink({ uri: API_URL })

export const client = new ApolloClient({
  link,
  cache: cache,
})

export const store = makeVar(null)
export const alertType = makeVar(null)
export const message = makeVar(null)
export const locationData = makeVar(null)
export const patientData = makeVar(null)
export const responsiblePartyData = makeVar(null)
export const appointmentRequestId = makeVar(null)

export const resetAvailabilityCache = () => {
  return client.refetchQueries({
    updateCache(cache) {
      cache.evict({ fieldName: 'appointmentAvailability' })
    },
  })
}
